import { useLocation, useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";
import { checkExistAuthStep1 } from "../../../../utils/auth";
import AuthMessageToUsers from "./AuthMessageToUsers";

const AuthBackBtn = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isTWA = () => {
    // Check if display-mode is standalone (used for TWA)
    const isStandalone = window.matchMedia(
      "(display-mode: standalone)",
    ).matches;

    // Additional check for userAgent (optional, based on common patterns)
    const isAndroid = navigator.userAgent.includes("Android");
    const isInTWA = navigator.userAgent.includes("TWA");

    // If either condition is true, consider it TWA
    return isStandalone || (isAndroid && isInTWA);
  };

  const handleBackStep = () => {
    if (location.pathname === "/auth/verify") {
      const isInputedPhone = checkExistAuthStep1();

      if (isInputedPhone?.mobile) {
        navigate("/auth/login");
      } else {
        if (!isTWA()) {
          navigateToSelectClient();
        }
      }
    } else if (!isTWA()) navigateToSelectClient();
  };

  const navigateToSelectClient = () => {
    localStorage.removeItem("selected-client-type");

    navigate("/select-client-type", { replace: true });
  };

  if (
    location.pathname === "/auth/verify" ||
    (!isTWA() && location.pathname === "/auth/login")
  ) {
    return (
      <div className="mb-14">
        <AuthMessageToUsers />

        <button
          onClick={handleBackStep}
          className="absolute top-4 left-4 md:top-8 md:left-12 lg:left-20 lg:top-10 
             w-10 h-10 bg-gradient-to-tr from-blue-500 to-indigo-600 text-white hover:from-blue-600 hover:to-indigo-700
             flex items-center justify-center 
             shadow-lg rounded-xl border border-blue-200
             transition-all duration-300 
             ring-4 ring-blue-500/30 ring-offset-2 animate-pulse
             hover:animate-none hover:bg-blue-50 
             z-10"
        >
          <ReactSVG
            className="w-5"
            src={`${process.env.PUBLIC_URL}/assets/images/icons/back.svg`}
          />
        </button>
      </div>
    );
  } else {
    return <></>;
  }
};

export default AuthBackBtn;
